<template>
  <div class="hover-modal-actions">
    <div class="box">
      <div class="item" @click="remove('left')"><i class="el-icon-back"></i>关闭左侧</div>
      <div class="item" @click="remove('right')"><i class="el-icon-right" />关闭右侧</div>
      <div class="item" @click="remove('all')"><i class="el-icon-close" />关闭其它</div>
      <div class="item" @click="reload()"><i class="el-icon-refresh-right" />刷新当前</div>
    </div>
  </div>
</template>

<script>
import './actions.scss'
import { mapActions } from 'vuex'
  export default {
    inject: ['reload'],
    methods: {
      ...mapActions('app', [
        'removeTabs'
      ]),
      remove(type){
        this.removeTabs(type)
      }
    },


  }
</script>

<style lang="scss">
</style>